import { withTranslation } from "react-i18next"
import { connect, useSelector } from "react-redux"
import React from "react"
import { Icon, Modal } from "semantic-ui-react"
import ReactSVG from "react-svg"
import ShopService from "../../images/shop-service.svg"
import AppointmentCalender from "../../images/appointment-calender.svg"
import AppliedDiscounts from "../../images/applied-discounts.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCar, faCheck } from "@fortawesome/pro-regular-svg-icons"
import UberLogo from "../../images/uber_logo.svg"
import CarAdviseLogo from "../../images/CarAdvise-LogoWhite.svg"
import { faCross } from "@fortawesome/pro-light-svg-icons"
import { faClose } from "@fortawesome/pro-solid-svg-icons"

const MembershipBenefitsList = ({ user, t }) => {
  const benefitsList = [
    {
      name: t("uberDiamond"),
      benefits: [t("oilChanges", { percentage: "40" }), t("saveUpTo", { percentage: "26" })],
      key: "diamond"
    },
    {
      name: t("uberPlatinum"),
      benefits: [t("oilChanges", { percentage: "20" }), t("saveUpTo", { percentage: "26" })],
      key: "platinum"
    },
    { name: t("uberGold"), benefits: [t("saveUpTo", { percentage: "26" })], key: "gold" },
    { name: t("uberBlue"), benefits: [t("saveUpTo", { percentage: "26" })], key: "blue" }
  ]

  return benefitsList.map((plan) => (
    <div
      className={`membership-tier-benefits-container ${
        user.affiliation_name.toLowerCase().includes(plan.key) ? "bg-red" : ""
      }`}
    >
      <div className="tier-title-container">
        <p className="tier-title">{plan.name}</p>
        {user.affiliation_name.toLowerCase().includes(plan.key) && (
          <p>
            <FontAwesomeIcon icon={faCheck} style={{ marginRight: "10px" }} />
            Your Tier
          </p>
        )}
      </div>

      {plan.benefits.map((benefit, i) => (
        <p>
          <Icon className="icon-padding color-primary" name="chevron right" />
          {benefit}
        </p>
      ))}
    </div>
  ))
}

const UberMembershipBenefits = ({ user, isOpen, closeModal, t }) => {
  return (
    <Modal open={isOpen} className="uber-membership-benefits-modal">
      <div>
        <div style={{ textAlign: "end" }}>
          <FontAwesomeIcon icon={faClose} onClick={() => closeModal()} />
        </div>

        <p className="title">{t("membershipBenefits")}</p>

        <img src={UberLogo} className="uber-logo" alt="UberLogo" />

        <div className="booking-steps-container">
          <div className="steps-container">
            <span className="step-number">1</span>
            <ReactSVG src={ShopService} />
            <p>{t("searchForServices")}</p>
          </div>
          <div className="steps-container">
            <span className="step-number">2</span>
            <ReactSVG src={AppointmentCalender} />
            <p>{t("bookAppointment")}</p>
          </div>
          <div className="steps-container">
            <span className="step-number">3</span>
            <ReactSVG src={AppliedDiscounts} />
            <p>{t("discountsApplied")}</p>
          </div>
        </div>

        <hr />

        <div className="drive-more-container">
          <FontAwesomeIcon icon={faCar} />
          <p>{t("driveMoreWithUber")}</p>
        </div>

        <MembershipBenefitsList user={user} t={t} />

        <p className="terms">{t("subjectToChange")}</p>
        <p className="terms">{t("basedOnSurvey")}</p>

        <div className="logo-container">
          <img src={CarAdviseLogo} alt="CarAdvise Logo" />
        </div>
      </div>
    </Modal>
  )
}

function mapStateToProps(state) {
  return {
    user: state.user
  }
}

export default connect(mapStateToProps)(withTranslation("uberMembershipBenefits")(UberMembershipBenefits))
